import React, { memo } from "react"
import styled from "styled-components"

import { Box, Flex, FlexColumn } from "components/box"
import { RoundedRectangleImage } from "components/image"
import { Paragraph } from "components/text"
import { Separator } from "components/separator"

import { ConsultationFragmentDoctor } from "typings/types"

const DoctorProfileMain = styled(Flex).attrs({
  flexDirection: ["row", "row", "column", "column"]
})`
  justify-content: center;
  align-items: center;
`

const DoctorProfilePhoto = styled(RoundedRectangleImage)`
  min-width: ${props => props.theme.space[7]};
  max-width: 12rem;
`

const DoctorProfileDetail: React.FC<{ name: string; value: string }> = memo(({ name, value }) => (
  <Box mb={4}>
    <Paragraph mb={2} bold>
      {name}
    </Paragraph>
    <Separator borderColor="seafoamBlue" mb={[0, 0, 4, 4]} />
    <Paragraph>{value}</Paragraph>
  </Box>
))

const DoctorProfile: React.FC<{ doctor: ConsultationFragmentDoctor }> = ({
  doctor: { fullName, photoUrl, qualification, medicalSchool, residency }
}) => (
  <>
    <DoctorProfileMain mb={[0, 0, 6, 6]}>
      {photoUrl && <DoctorProfilePhoto src={photoUrl} />}
      <Box mt={[0, null, 5]} ml={[5, null, 0]} mr={[2, null, 0]} textAlign={["left", null, "center"]}>
        <Paragraph>{fullName}</Paragraph>
        <Paragraph>Board Certified Doctor</Paragraph>
      </Box>
    </DoctorProfileMain>
    <Flex justifyContent="center" alignItems="center">
      <FlexColumn maxWidth={[300, null, 200]} mt={[4, null, 0]}>
        {qualification && <DoctorProfileDetail name="Qualifications" value={qualification} />}
        {medicalSchool && <DoctorProfileDetail name="Education" value={medicalSchool} />}
        {residency && <DoctorProfileDetail name="Residency" value={residency} />}
      </FlexColumn>
    </Flex>
  </>
)

export default memo(DoctorProfile)
